
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investors/shareholder-information",
      function () {
        return require("private-next-pages/investors/shareholder-information.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investors/shareholder-information"])
      });
    }
  